import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import ReactPlayer from 'react-player'
import { Link, useParams } from 'react-router-dom'
import Videos from '../component/Videos'
import { fetchFromAPI } from '../utils/fetchFromApi'

import '../App.css'

import ChannelName from '../component/ChannelName';

import VideoCard from '../component/VideoCard';


const VideoDetail = () => {
  const[videoDetail, setVideoDetail]=useState(null);
  const[videos, setVideos]=useState(null)
  const{id}=useParams();
  useEffect(()=>{
    fetchFromAPI(`videos?part=snippet,statistics=${id}`)
    .then((data)=>setVideoDetail(data.items[0])).catch((err)=>{
      console.log(`what is this error ${err}`)
    })


    fetchFromAPI(`search?part=snippet&relatedToVideoId=${id}&type=video`)
    .then((data)=>setVideos(data.items))
  },[id]);
    
  
  return(
    <>
     <div className="container-fluid p-0">
      <div className="row m-0" style={{ height:"100vh"}} >
        <div className="col-12 col-sm-12 col-md-8 col-lg-8 border p-0">
          <div>
          <ReactPlayer url={`https://www.youtube.com/watch?v=${id}`} className="react-player " controls />
          </div>
        
          
        </div>

        <div className='col-10 col-sm-10 col-md-3 m-auto '>
        {
          videos && videos.map((item, index)=>{
            return(
              <div className=""  key={index} >
                    {item.id.videoId && <VideoCard video={item} />}
                    {item.id.channelId && <ChannelName channelDetail={item} />}
              </div>
            )
          })
        }
        </div>
      </div>
     </div>
    </>
  )
}

export default VideoDetail
